import { PhoneNumber } from '@weave/schema-gen-ts/dist/schemas/phone/callroute/v1/callroute_service.pb';

export const sortRoutePhoneNumbers = (phoneNumbers: PhoneNumber[]) =>
  [...phoneNumbers].sort((a, b) => a.phoneNumber.localeCompare(b.phoneNumber, undefined, { numeric: true }));

export const sortRouteExtensionNumbers = (extensionNumbers: number[]) => [...extensionNumbers].sort((a, b) => a - b);
